import { bytesToKB } from '../../../utility/helpers';
import { NUMBERS } from '../../../resources/number-constants';
import { DocxIcon, pdfIcon, profileImg } from '../../../assets/images/images';

const itemLabels: any = {
    great_candidate: 'What makes you a great candidate?',
    work_on: 'What would you work on?',
    could_have: 'Could-Haves',
    good_to_have: 'Good-to-Haves',
    must_have: 'Must-Haves',
    should_have: 'Should-Haves'
};

const OutgoingMessage = ({
    chat,
    companyLogo,
    isFromJob = false
}: any) => {
    const renderTitle = () => {
        if (Array.isArray(chat?.payload?.title)) {
            return chat.payload.title.join(', ');
        } else if (!chat?.payload?.title && chat?.payload?.message) {
            return chat?.payload?.message;
        } else if (chat?.payload?.title && !chat?.payload?.message) {
            return Object.values(chat?.payload?.title)[0];
        }
        const title = chat?.payload?.title;
        if (typeof title === 'string') {
            const lowerCaseTitle = title.toLowerCase();
            return itemLabels[lowerCaseTitle] || title;
        }
        return title;
    };

    const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
        e.currentTarget.src = profileImg;
    };
    return (
        <>
            <div className="outgoing_msg">
                <div className="sent_msg">
                    {(chat?.payload_type === NUMBERS.THREE) && (
                        <p>
                            {renderTitle()}
                        </p>
                    )}

                    {(chat?.payload_type === 1) && (
                        <p>
                            <div className='chat-document-wrap'>
                                {chat?.file_name?.endsWith('.pdf') ? (
                                    <img src={pdfIcon} alt="document" className='document-img' />
                                ) : (
                                    <img src={DocxIcon} alt="document" className='document-img' />
                                )}
                                <span className='document-name'>{chat?.file_name || ''}</span>
                                <span className='document-size'>{bytesToKB(chat?.file_size || 0)}</span>
                            </div>
                        </p>
                    )}
                    {(chat?.payload_type === NUMBERS.TWO) && (
                        <p>
                            <div className='chat-document-wrap'>
                                {chat?.file_url?.endsWith('.pdf') ? (
                                    <img src={pdfIcon} alt="document" className='document-img' />
                                ) : (
                                    <img src={DocxIcon} alt="document" className='document-img' />
                                )}
                                <span className='document-name'>{chat?.file_name || ''}</span>
                                <span className='document-size'>{bytesToKB(chat?.file_size || 0)}</span>
                            </div>
                        </p>
                    )}
                </div>
                    <div className={`outgoing_msg_img ${isFromJob ? 'd-none' : ''}`}>
                        <img
                            src={companyLogo || profileImg}
                            alt="user"
                            onError={handleImageError}
                            loading="lazy"
                            className="chat-user-profile-img"
                        />
                    </div>
            </div>
        </>
    );
};

export default OutgoingMessage;
